/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as OnboardingRouteImport } from "./routes/onboarding"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as AuthedRouteRouteImport } from "./routes/_authed/route"
import { Route as AuthedIndexRouteImport } from "./routes/_authed/index"
import { Route as AuthedStrategyLabRouteImport } from "./routes/_authed/strategy-lab"
import { Route as AuthedSettingsRouteImport } from "./routes/_authed/settings"
import { Route as AuthedPortfoliosRouteImport } from "./routes/_authed/portfolios"
import { Route as AuthedOperatingStrategyRouteImport } from "./routes/_authed/operating-strategy"
import { Route as AuthedManagedGroupsRouteImport } from "./routes/_authed/managed-groups"
import { Route as AuthedBudgetPlanningRouteImport } from "./routes/_authed/budget-planning"
import { Route as AuthedApprovalsRouteImport } from "./routes/_authed/approvals"
import { Route as AuthedAmazonSelectProfileRouteImport } from "./routes/_authed/amazon-select-profile"
import { Route as AuthedAllProductsRouteImport } from "./routes/_authed/all-products"
import { Route as AuthedAiOperationsRouteImport } from "./routes/_authed/ai-operations"
import { Route as AuthedAccountRouteImport } from "./routes/_authed/account"
import { Route as AuthedCampaignsIndexRouteImport } from "./routes/_authed/campaigns/index"
import { Route as AuthAmazonSpApiCallbackRouteImport } from "./routes/auth.amazon.sp-api-callback"
import { Route as AuthAmazonCallbackRouteImport } from "./routes/auth.amazon.callback"
import { Route as AuthAmazonAdsCallbackRouteImport } from "./routes/auth.amazon.ads-callback"
import { Route as AuthedPortfoliosIdRouteImport } from "./routes/_authed/portfolios_.$id"
import { Route as AuthedManagedGroupsIdRouteImport } from "./routes/_authed/managed-groups_.$id"
import { Route as AuthedComingSoonFeatureRouteImport } from "./routes/_authed/coming-soon/$feature"
import { Route as AuthedCampaignsTemplatePortfolioRouteImport } from "./routes/_authed/campaigns/template-portfolio"
import { Route as AuthedCampaignsNewRouteImport } from "./routes/_authed/campaigns/new"
import { Route as AuthedAmcModelsRouteImport } from "./routes/_authed/amc/models"
import { Route as AuthedAmcAudiencesRouteImport } from "./routes/_authed/amc/audiences"
import { Route as AuthedAiOperationsRunIdRouteImport } from "./routes/_authed/ai-operations_.$runId"
import { Route as AuthedCampaignsIdIndexRouteImport } from "./routes/_authed/campaigns/$id.index"
import { Route as AuthedCampaignsNewRequestIdRouteImport } from "./routes/_authed/campaigns/new_.$requestId"
import { Route as AuthedCampaignsIdAiSetupRouteImport } from "./routes/_authed/campaigns/$id.ai-setup"
import { Route as AuthedAiOperationsActionsOperationIdRouteImport } from "./routes/_authed/ai-operations_.actions.$operationId"
import { Route as AuthedCampaignsIdAdGroupsAdGroupIdRouteImport } from "./routes/_authed/campaigns/$id.ad-groups.$adGroupId"

const OnboardingRoute = OnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedStrategyLabRoute = AuthedStrategyLabRouteImport.update({
  id: "/strategy-lab",
  path: "/strategy-lab",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedPortfoliosRoute = AuthedPortfoliosRouteImport.update({
  id: "/portfolios",
  path: "/portfolios",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedOperatingStrategyRoute = AuthedOperatingStrategyRouteImport.update({
  id: "/operating-strategy",
  path: "/operating-strategy",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedManagedGroupsRoute = AuthedManagedGroupsRouteImport.update({
  id: "/managed-groups",
  path: "/managed-groups",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedBudgetPlanningRoute = AuthedBudgetPlanningRouteImport.update({
  id: "/budget-planning",
  path: "/budget-planning",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedApprovalsRoute = AuthedApprovalsRouteImport.update({
  id: "/approvals",
  path: "/approvals",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAmazonSelectProfileRoute =
  AuthedAmazonSelectProfileRouteImport.update({
    id: "/amazon-select-profile",
    path: "/amazon-select-profile",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedAllProductsRoute = AuthedAllProductsRouteImport.update({
  id: "/all-products",
  path: "/all-products",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAiOperationsRoute = AuthedAiOperationsRouteImport.update({
  id: "/ai-operations",
  path: "/ai-operations",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAccountRoute = AuthedAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedCampaignsIndexRoute = AuthedCampaignsIndexRouteImport.update({
  id: "/campaigns/",
  path: "/campaigns/",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthAmazonSpApiCallbackRoute = AuthAmazonSpApiCallbackRouteImport.update({
  id: "/auth/amazon/sp-api-callback",
  path: "/auth/amazon/sp-api-callback",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAmazonCallbackRoute = AuthAmazonCallbackRouteImport.update({
  id: "/auth/amazon/callback",
  path: "/auth/amazon/callback",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAmazonAdsCallbackRoute = AuthAmazonAdsCallbackRouteImport.update({
  id: "/auth/amazon/ads-callback",
  path: "/auth/amazon/ads-callback",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedPortfoliosIdRoute = AuthedPortfoliosIdRouteImport.update({
  id: "/portfolios_/$id",
  path: "/portfolios/$id",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedManagedGroupsIdRoute = AuthedManagedGroupsIdRouteImport.update({
  id: "/managed-groups_/$id",
  path: "/managed-groups/$id",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedComingSoonFeatureRoute = AuthedComingSoonFeatureRouteImport.update({
  id: "/coming-soon/$feature",
  path: "/coming-soon/$feature",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedCampaignsTemplatePortfolioRoute =
  AuthedCampaignsTemplatePortfolioRouteImport.update({
    id: "/campaigns/template-portfolio",
    path: "/campaigns/template-portfolio",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedCampaignsNewRoute = AuthedCampaignsNewRouteImport.update({
  id: "/campaigns/new",
  path: "/campaigns/new",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAmcModelsRoute = AuthedAmcModelsRouteImport.update({
  id: "/amc/models",
  path: "/amc/models",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAmcAudiencesRoute = AuthedAmcAudiencesRouteImport.update({
  id: "/amc/audiences",
  path: "/amc/audiences",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAiOperationsRunIdRoute = AuthedAiOperationsRunIdRouteImport.update({
  id: "/ai-operations_/$runId",
  path: "/ai-operations/$runId",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedCampaignsIdIndexRoute = AuthedCampaignsIdIndexRouteImport.update({
  id: "/campaigns/$id/",
  path: "/campaigns/$id/",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedCampaignsNewRequestIdRoute =
  AuthedCampaignsNewRequestIdRouteImport.update({
    id: "/campaigns/new_/$requestId",
    path: "/campaigns/new/$requestId",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedCampaignsIdAiSetupRoute =
  AuthedCampaignsIdAiSetupRouteImport.update({
    id: "/campaigns/$id/ai-setup",
    path: "/campaigns/$id/ai-setup",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedAiOperationsActionsOperationIdRoute =
  AuthedAiOperationsActionsOperationIdRouteImport.update({
    id: "/ai-operations_/actions/$operationId",
    path: "/ai-operations/actions/$operationId",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedCampaignsIdAdGroupsAdGroupIdRoute =
  AuthedCampaignsIdAdGroupsAdGroupIdRouteImport.update({
    id: "/campaigns/$id/ad-groups/$adGroupId",
    path: "/campaigns/$id/ad-groups/$adGroupId",
    getParentRoute: () => AuthedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof AuthedIndexRoute
  "/login": typeof LoginRoute
  "/onboarding": typeof OnboardingRoute
  "/account": typeof AuthedAccountRoute
  "/ai-operations": typeof AuthedAiOperationsRoute
  "/all-products": typeof AuthedAllProductsRoute
  "/amazon-select-profile": typeof AuthedAmazonSelectProfileRoute
  "/approvals": typeof AuthedApprovalsRoute
  "/budget-planning": typeof AuthedBudgetPlanningRoute
  "/managed-groups": typeof AuthedManagedGroupsRoute
  "/operating-strategy": typeof AuthedOperatingStrategyRoute
  "/portfolios": typeof AuthedPortfoliosRoute
  "/settings": typeof AuthedSettingsRoute
  "/strategy-lab": typeof AuthedStrategyLabRoute
  "/ai-operations/$runId": typeof AuthedAiOperationsRunIdRoute
  "/amc/audiences": typeof AuthedAmcAudiencesRoute
  "/amc/models": typeof AuthedAmcModelsRoute
  "/campaigns/new": typeof AuthedCampaignsNewRoute
  "/campaigns/template-portfolio": typeof AuthedCampaignsTemplatePortfolioRoute
  "/coming-soon/$feature": typeof AuthedComingSoonFeatureRoute
  "/managed-groups/$id": typeof AuthedManagedGroupsIdRoute
  "/portfolios/$id": typeof AuthedPortfoliosIdRoute
  "/auth/amazon/ads-callback": typeof AuthAmazonAdsCallbackRoute
  "/auth/amazon/callback": typeof AuthAmazonCallbackRoute
  "/auth/amazon/sp-api-callback": typeof AuthAmazonSpApiCallbackRoute
  "/campaigns/": typeof AuthedCampaignsIndexRoute
  "/ai-operations/actions/$operationId": typeof AuthedAiOperationsActionsOperationIdRoute
  "/campaigns/$id/ai-setup": typeof AuthedCampaignsIdAiSetupRoute
  "/campaigns/new/$requestId": typeof AuthedCampaignsNewRequestIdRoute
  "/campaigns/$id/": typeof AuthedCampaignsIdIndexRoute
  "/campaigns/$id/ad-groups/$adGroupId": typeof AuthedCampaignsIdAdGroupsAdGroupIdRoute
}
export interface FileRoutesByTo {
  "/login": typeof LoginRoute
  "/onboarding": typeof OnboardingRoute
  "/account": typeof AuthedAccountRoute
  "/ai-operations": typeof AuthedAiOperationsRoute
  "/all-products": typeof AuthedAllProductsRoute
  "/amazon-select-profile": typeof AuthedAmazonSelectProfileRoute
  "/approvals": typeof AuthedApprovalsRoute
  "/budget-planning": typeof AuthedBudgetPlanningRoute
  "/managed-groups": typeof AuthedManagedGroupsRoute
  "/operating-strategy": typeof AuthedOperatingStrategyRoute
  "/portfolios": typeof AuthedPortfoliosRoute
  "/settings": typeof AuthedSettingsRoute
  "/strategy-lab": typeof AuthedStrategyLabRoute
  "/": typeof AuthedIndexRoute
  "/ai-operations/$runId": typeof AuthedAiOperationsRunIdRoute
  "/amc/audiences": typeof AuthedAmcAudiencesRoute
  "/amc/models": typeof AuthedAmcModelsRoute
  "/campaigns/new": typeof AuthedCampaignsNewRoute
  "/campaigns/template-portfolio": typeof AuthedCampaignsTemplatePortfolioRoute
  "/coming-soon/$feature": typeof AuthedComingSoonFeatureRoute
  "/managed-groups/$id": typeof AuthedManagedGroupsIdRoute
  "/portfolios/$id": typeof AuthedPortfoliosIdRoute
  "/auth/amazon/ads-callback": typeof AuthAmazonAdsCallbackRoute
  "/auth/amazon/callback": typeof AuthAmazonCallbackRoute
  "/auth/amazon/sp-api-callback": typeof AuthAmazonSpApiCallbackRoute
  "/campaigns": typeof AuthedCampaignsIndexRoute
  "/ai-operations/actions/$operationId": typeof AuthedAiOperationsActionsOperationIdRoute
  "/campaigns/$id/ai-setup": typeof AuthedCampaignsIdAiSetupRoute
  "/campaigns/new/$requestId": typeof AuthedCampaignsNewRequestIdRoute
  "/campaigns/$id": typeof AuthedCampaignsIdIndexRoute
  "/campaigns/$id/ad-groups/$adGroupId": typeof AuthedCampaignsIdAdGroupsAdGroupIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_authed": typeof AuthedRouteRouteWithChildren
  "/login": typeof LoginRoute
  "/onboarding": typeof OnboardingRoute
  "/_authed/account": typeof AuthedAccountRoute
  "/_authed/ai-operations": typeof AuthedAiOperationsRoute
  "/_authed/all-products": typeof AuthedAllProductsRoute
  "/_authed/amazon-select-profile": typeof AuthedAmazonSelectProfileRoute
  "/_authed/approvals": typeof AuthedApprovalsRoute
  "/_authed/budget-planning": typeof AuthedBudgetPlanningRoute
  "/_authed/managed-groups": typeof AuthedManagedGroupsRoute
  "/_authed/operating-strategy": typeof AuthedOperatingStrategyRoute
  "/_authed/portfolios": typeof AuthedPortfoliosRoute
  "/_authed/settings": typeof AuthedSettingsRoute
  "/_authed/strategy-lab": typeof AuthedStrategyLabRoute
  "/_authed/": typeof AuthedIndexRoute
  "/_authed/ai-operations_/$runId": typeof AuthedAiOperationsRunIdRoute
  "/_authed/amc/audiences": typeof AuthedAmcAudiencesRoute
  "/_authed/amc/models": typeof AuthedAmcModelsRoute
  "/_authed/campaigns/new": typeof AuthedCampaignsNewRoute
  "/_authed/campaigns/template-portfolio": typeof AuthedCampaignsTemplatePortfolioRoute
  "/_authed/coming-soon/$feature": typeof AuthedComingSoonFeatureRoute
  "/_authed/managed-groups_/$id": typeof AuthedManagedGroupsIdRoute
  "/_authed/portfolios_/$id": typeof AuthedPortfoliosIdRoute
  "/auth/amazon/ads-callback": typeof AuthAmazonAdsCallbackRoute
  "/auth/amazon/callback": typeof AuthAmazonCallbackRoute
  "/auth/amazon/sp-api-callback": typeof AuthAmazonSpApiCallbackRoute
  "/_authed/campaigns/": typeof AuthedCampaignsIndexRoute
  "/_authed/ai-operations_/actions/$operationId": typeof AuthedAiOperationsActionsOperationIdRoute
  "/_authed/campaigns/$id/ai-setup": typeof AuthedCampaignsIdAiSetupRoute
  "/_authed/campaigns/new_/$requestId": typeof AuthedCampaignsNewRequestIdRoute
  "/_authed/campaigns/$id/": typeof AuthedCampaignsIdIndexRoute
  "/_authed/campaigns/$id/ad-groups/$adGroupId": typeof AuthedCampaignsIdAdGroupsAdGroupIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/login"
    | "/onboarding"
    | "/account"
    | "/ai-operations"
    | "/all-products"
    | "/amazon-select-profile"
    | "/approvals"
    | "/budget-planning"
    | "/managed-groups"
    | "/operating-strategy"
    | "/portfolios"
    | "/settings"
    | "/strategy-lab"
    | "/ai-operations/$runId"
    | "/amc/audiences"
    | "/amc/models"
    | "/campaigns/new"
    | "/campaigns/template-portfolio"
    | "/coming-soon/$feature"
    | "/managed-groups/$id"
    | "/portfolios/$id"
    | "/auth/amazon/ads-callback"
    | "/auth/amazon/callback"
    | "/auth/amazon/sp-api-callback"
    | "/campaigns/"
    | "/ai-operations/actions/$operationId"
    | "/campaigns/$id/ai-setup"
    | "/campaigns/new/$requestId"
    | "/campaigns/$id/"
    | "/campaigns/$id/ad-groups/$adGroupId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/login"
    | "/onboarding"
    | "/account"
    | "/ai-operations"
    | "/all-products"
    | "/amazon-select-profile"
    | "/approvals"
    | "/budget-planning"
    | "/managed-groups"
    | "/operating-strategy"
    | "/portfolios"
    | "/settings"
    | "/strategy-lab"
    | "/"
    | "/ai-operations/$runId"
    | "/amc/audiences"
    | "/amc/models"
    | "/campaigns/new"
    | "/campaigns/template-portfolio"
    | "/coming-soon/$feature"
    | "/managed-groups/$id"
    | "/portfolios/$id"
    | "/auth/amazon/ads-callback"
    | "/auth/amazon/callback"
    | "/auth/amazon/sp-api-callback"
    | "/campaigns"
    | "/ai-operations/actions/$operationId"
    | "/campaigns/$id/ai-setup"
    | "/campaigns/new/$requestId"
    | "/campaigns/$id"
    | "/campaigns/$id/ad-groups/$adGroupId"
  id:
    | "__root__"
    | "/_authed"
    | "/login"
    | "/onboarding"
    | "/_authed/account"
    | "/_authed/ai-operations"
    | "/_authed/all-products"
    | "/_authed/amazon-select-profile"
    | "/_authed/approvals"
    | "/_authed/budget-planning"
    | "/_authed/managed-groups"
    | "/_authed/operating-strategy"
    | "/_authed/portfolios"
    | "/_authed/settings"
    | "/_authed/strategy-lab"
    | "/_authed/"
    | "/_authed/ai-operations_/$runId"
    | "/_authed/amc/audiences"
    | "/_authed/amc/models"
    | "/_authed/campaigns/new"
    | "/_authed/campaigns/template-portfolio"
    | "/_authed/coming-soon/$feature"
    | "/_authed/managed-groups_/$id"
    | "/_authed/portfolios_/$id"
    | "/auth/amazon/ads-callback"
    | "/auth/amazon/callback"
    | "/auth/amazon/sp-api-callback"
    | "/_authed/campaigns/"
    | "/_authed/ai-operations_/actions/$operationId"
    | "/_authed/campaigns/$id/ai-setup"
    | "/_authed/campaigns/new_/$requestId"
    | "/_authed/campaigns/$id/"
    | "/_authed/campaigns/$id/ad-groups/$adGroupId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  AuthAmazonAdsCallbackRoute: typeof AuthAmazonAdsCallbackRoute
  AuthAmazonCallbackRoute: typeof AuthAmazonCallbackRoute
  AuthAmazonSpApiCallbackRoute: typeof AuthAmazonSpApiCallbackRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/onboarding": {
      id: "/onboarding"
      path: "/onboarding"
      fullPath: "/onboarding"
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed": {
      id: "/_authed"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/": {
      id: "/_authed/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/strategy-lab": {
      id: "/_authed/strategy-lab"
      path: "/strategy-lab"
      fullPath: "/strategy-lab"
      preLoaderRoute: typeof AuthedStrategyLabRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/settings": {
      id: "/_authed/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/portfolios": {
      id: "/_authed/portfolios"
      path: "/portfolios"
      fullPath: "/portfolios"
      preLoaderRoute: typeof AuthedPortfoliosRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/operating-strategy": {
      id: "/_authed/operating-strategy"
      path: "/operating-strategy"
      fullPath: "/operating-strategy"
      preLoaderRoute: typeof AuthedOperatingStrategyRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/managed-groups": {
      id: "/_authed/managed-groups"
      path: "/managed-groups"
      fullPath: "/managed-groups"
      preLoaderRoute: typeof AuthedManagedGroupsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/budget-planning": {
      id: "/_authed/budget-planning"
      path: "/budget-planning"
      fullPath: "/budget-planning"
      preLoaderRoute: typeof AuthedBudgetPlanningRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/approvals": {
      id: "/_authed/approvals"
      path: "/approvals"
      fullPath: "/approvals"
      preLoaderRoute: typeof AuthedApprovalsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/amazon-select-profile": {
      id: "/_authed/amazon-select-profile"
      path: "/amazon-select-profile"
      fullPath: "/amazon-select-profile"
      preLoaderRoute: typeof AuthedAmazonSelectProfileRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/all-products": {
      id: "/_authed/all-products"
      path: "/all-products"
      fullPath: "/all-products"
      preLoaderRoute: typeof AuthedAllProductsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/ai-operations": {
      id: "/_authed/ai-operations"
      path: "/ai-operations"
      fullPath: "/ai-operations"
      preLoaderRoute: typeof AuthedAiOperationsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/account": {
      id: "/_authed/account"
      path: "/account"
      fullPath: "/account"
      preLoaderRoute: typeof AuthedAccountRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/campaigns/": {
      id: "/_authed/campaigns/"
      path: "/campaigns"
      fullPath: "/campaigns/"
      preLoaderRoute: typeof AuthedCampaignsIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/auth/amazon/sp-api-callback": {
      id: "/auth/amazon/sp-api-callback"
      path: "/auth/amazon/sp-api-callback"
      fullPath: "/auth/amazon/sp-api-callback"
      preLoaderRoute: typeof AuthAmazonSpApiCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/amazon/callback": {
      id: "/auth/amazon/callback"
      path: "/auth/amazon/callback"
      fullPath: "/auth/amazon/callback"
      preLoaderRoute: typeof AuthAmazonCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/amazon/ads-callback": {
      id: "/auth/amazon/ads-callback"
      path: "/auth/amazon/ads-callback"
      fullPath: "/auth/amazon/ads-callback"
      preLoaderRoute: typeof AuthAmazonAdsCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/portfolios_/$id": {
      id: "/_authed/portfolios_/$id"
      path: "/portfolios/$id"
      fullPath: "/portfolios/$id"
      preLoaderRoute: typeof AuthedPortfoliosIdRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/managed-groups_/$id": {
      id: "/_authed/managed-groups_/$id"
      path: "/managed-groups/$id"
      fullPath: "/managed-groups/$id"
      preLoaderRoute: typeof AuthedManagedGroupsIdRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/coming-soon/$feature": {
      id: "/_authed/coming-soon/$feature"
      path: "/coming-soon/$feature"
      fullPath: "/coming-soon/$feature"
      preLoaderRoute: typeof AuthedComingSoonFeatureRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/campaigns/template-portfolio": {
      id: "/_authed/campaigns/template-portfolio"
      path: "/campaigns/template-portfolio"
      fullPath: "/campaigns/template-portfolio"
      preLoaderRoute: typeof AuthedCampaignsTemplatePortfolioRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/campaigns/new": {
      id: "/_authed/campaigns/new"
      path: "/campaigns/new"
      fullPath: "/campaigns/new"
      preLoaderRoute: typeof AuthedCampaignsNewRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/amc/models": {
      id: "/_authed/amc/models"
      path: "/amc/models"
      fullPath: "/amc/models"
      preLoaderRoute: typeof AuthedAmcModelsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/amc/audiences": {
      id: "/_authed/amc/audiences"
      path: "/amc/audiences"
      fullPath: "/amc/audiences"
      preLoaderRoute: typeof AuthedAmcAudiencesRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/ai-operations_/$runId": {
      id: "/_authed/ai-operations_/$runId"
      path: "/ai-operations/$runId"
      fullPath: "/ai-operations/$runId"
      preLoaderRoute: typeof AuthedAiOperationsRunIdRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/campaigns/$id/": {
      id: "/_authed/campaigns/$id/"
      path: "/campaigns/$id"
      fullPath: "/campaigns/$id/"
      preLoaderRoute: typeof AuthedCampaignsIdIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/campaigns/new_/$requestId": {
      id: "/_authed/campaigns/new_/$requestId"
      path: "/campaigns/new/$requestId"
      fullPath: "/campaigns/new/$requestId"
      preLoaderRoute: typeof AuthedCampaignsNewRequestIdRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/campaigns/$id/ai-setup": {
      id: "/_authed/campaigns/$id/ai-setup"
      path: "/campaigns/$id/ai-setup"
      fullPath: "/campaigns/$id/ai-setup"
      preLoaderRoute: typeof AuthedCampaignsIdAiSetupRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/ai-operations_/actions/$operationId": {
      id: "/_authed/ai-operations_/actions/$operationId"
      path: "/ai-operations/actions/$operationId"
      fullPath: "/ai-operations/actions/$operationId"
      preLoaderRoute: typeof AuthedAiOperationsActionsOperationIdRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/campaigns/$id/ad-groups/$adGroupId": {
      id: "/_authed/campaigns/$id/ad-groups/$adGroupId"
      path: "/campaigns/$id/ad-groups/$adGroupId"
      fullPath: "/campaigns/$id/ad-groups/$adGroupId"
      preLoaderRoute: typeof AuthedCampaignsIdAdGroupsAdGroupIdRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
  }
}

interface AuthedRouteRouteChildren {
  AuthedAccountRoute: typeof AuthedAccountRoute
  AuthedAiOperationsRoute: typeof AuthedAiOperationsRoute
  AuthedAllProductsRoute: typeof AuthedAllProductsRoute
  AuthedAmazonSelectProfileRoute: typeof AuthedAmazonSelectProfileRoute
  AuthedApprovalsRoute: typeof AuthedApprovalsRoute
  AuthedBudgetPlanningRoute: typeof AuthedBudgetPlanningRoute
  AuthedManagedGroupsRoute: typeof AuthedManagedGroupsRoute
  AuthedOperatingStrategyRoute: typeof AuthedOperatingStrategyRoute
  AuthedPortfoliosRoute: typeof AuthedPortfoliosRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedStrategyLabRoute: typeof AuthedStrategyLabRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAiOperationsRunIdRoute: typeof AuthedAiOperationsRunIdRoute
  AuthedAmcAudiencesRoute: typeof AuthedAmcAudiencesRoute
  AuthedAmcModelsRoute: typeof AuthedAmcModelsRoute
  AuthedCampaignsNewRoute: typeof AuthedCampaignsNewRoute
  AuthedCampaignsTemplatePortfolioRoute: typeof AuthedCampaignsTemplatePortfolioRoute
  AuthedComingSoonFeatureRoute: typeof AuthedComingSoonFeatureRoute
  AuthedManagedGroupsIdRoute: typeof AuthedManagedGroupsIdRoute
  AuthedPortfoliosIdRoute: typeof AuthedPortfoliosIdRoute
  AuthedCampaignsIndexRoute: typeof AuthedCampaignsIndexRoute
  AuthedAiOperationsActionsOperationIdRoute: typeof AuthedAiOperationsActionsOperationIdRoute
  AuthedCampaignsIdAiSetupRoute: typeof AuthedCampaignsIdAiSetupRoute
  AuthedCampaignsNewRequestIdRoute: typeof AuthedCampaignsNewRequestIdRoute
  AuthedCampaignsIdIndexRoute: typeof AuthedCampaignsIdIndexRoute
  AuthedCampaignsIdAdGroupsAdGroupIdRoute: typeof AuthedCampaignsIdAdGroupsAdGroupIdRoute
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedAccountRoute: AuthedAccountRoute,
  AuthedAiOperationsRoute: AuthedAiOperationsRoute,
  AuthedAllProductsRoute: AuthedAllProductsRoute,
  AuthedAmazonSelectProfileRoute: AuthedAmazonSelectProfileRoute,
  AuthedApprovalsRoute: AuthedApprovalsRoute,
  AuthedBudgetPlanningRoute: AuthedBudgetPlanningRoute,
  AuthedManagedGroupsRoute: AuthedManagedGroupsRoute,
  AuthedOperatingStrategyRoute: AuthedOperatingStrategyRoute,
  AuthedPortfoliosRoute: AuthedPortfoliosRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedStrategyLabRoute: AuthedStrategyLabRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAiOperationsRunIdRoute: AuthedAiOperationsRunIdRoute,
  AuthedAmcAudiencesRoute: AuthedAmcAudiencesRoute,
  AuthedAmcModelsRoute: AuthedAmcModelsRoute,
  AuthedCampaignsNewRoute: AuthedCampaignsNewRoute,
  AuthedCampaignsTemplatePortfolioRoute: AuthedCampaignsTemplatePortfolioRoute,
  AuthedComingSoonFeatureRoute: AuthedComingSoonFeatureRoute,
  AuthedManagedGroupsIdRoute: AuthedManagedGroupsIdRoute,
  AuthedPortfoliosIdRoute: AuthedPortfoliosIdRoute,
  AuthedCampaignsIndexRoute: AuthedCampaignsIndexRoute,
  AuthedAiOperationsActionsOperationIdRoute:
    AuthedAiOperationsActionsOperationIdRoute,
  AuthedCampaignsIdAiSetupRoute: AuthedCampaignsIdAiSetupRoute,
  AuthedCampaignsNewRequestIdRoute: AuthedCampaignsNewRequestIdRoute,
  AuthedCampaignsIdIndexRoute: AuthedCampaignsIdIndexRoute,
  AuthedCampaignsIdAdGroupsAdGroupIdRoute:
    AuthedCampaignsIdAdGroupsAdGroupIdRoute,
}

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  AuthAmazonAdsCallbackRoute: AuthAmazonAdsCallbackRoute,
  AuthAmazonCallbackRoute: AuthAmazonCallbackRoute,
  AuthAmazonSpApiCallbackRoute: AuthAmazonSpApiCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
